<template>
  <div class="login background">
    <!-- <img class="background" src="@/assets/background-2.jpg" alt /> -->
    <!-- <a href="https://www.chance4talents.de">
      <img class="logo-round" src="@/assets/logo-small.png" alt="" />
    </a> -->
    <v-card class="login-wrapper" dark>
      <h1>WILLKOMMEN BEIM <span style="color: #2cc54b">LOGIN</span> VON CHANCE4TALENTS</h1>
      <div class="column">
        <v-text-field outlined color="green" v-model="usermail" label="E-Mail-Adresse"></v-text-field>
        <v-text-field outlined
          color="green"
          :append-icon="showPWW ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPWW ? 'text' : 'password'"
          v-model="password"
          @click:append="showPWW = !showPWW"
          label="Passwort"></v-text-field>
        <Button
          @click="login(usermail,password, user_type)"
          :loading="$store.state.loading"
          rounded
          :label="'JETZT EINLOGGEN'"
        >JETZT EINLOGGEN</Button>
        <div class="row">
          <v-divider class="divider"></v-divider>oder
          <v-divider class="divider"></v-divider>
        </div>
        <RegisterButton @click="redirectToRegister" :label="'HAST DU NOCH KEINEN ACCOUNT?'"></RegisterButton>
        <div>
          <v-dialog v-model="dialog" width="350">
            <template v-slot:activator="{ on }">
              <a class="forgotPW" href="#" v-on="on">Passwort vergessen?</a>
            </template>

            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>Passwort zurücksetzen</v-card-title>

              <v-card-text class="card-text">
                <p>Gib hier deine E-Mail ein und du erhältst einen Link mit dem du dein Passwort zurücksetzen kannst.</p>
                <v-text-field outlined color="green" v-model="usermail" label="E-Mail"></v-text-field>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions style="justify-content: center;">
                <v-btn
                  :disabled="usermail.length==''"
                  color="green white--text"
                  text
                  @click="sendResetMail(usermail)"
                >Neues Passwort</v-btn>
                <v-btn text @click="dialog = false">Schließen</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import firebase from 'firebase';
import Button from '@/components/Button';
import RegisterButton from '@/components/RegisterButton';
import commonMixin from '@/mixins/common';
import { db } from '@/db';

export default {
  components: {
    Button,
    RegisterButton,
  },

  mixins: [commonMixin],

  data: () => ({
    loginAnimation: {
      classes: 'zoomIn',
      delay: 0,
      duration: 400,
    },
    showPWW: false,
    dialog: false,
    register_loading: false,
    usermail: '',
    password: '',
    register: false,
    user_type: 'Spieler',
  }),

  methods: {
    sendbacktoWebsite() {
      window.href = 'www.google.de';
    },
    sendResetMail(usermail) {
      firebase
        .auth()
        .sendPasswordResetEmail(usermail)
        .then(() => {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'E-Mail erfolgreich gesendet',
          });
          this.dialog = false;
        })
        .catch((error) => {
          // An error happened.
          if (error.code == 'auth/invalid-email') {
            this.$store.commit({
              type: 'openSnackbar',
              text: 'Falsches E-Mail Format',
            });
          }
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Benutzer nicht vorhanden',
          });
        });
    },
    redirectToRegister() {
      window.location = 'https://www.chance4talents.de/wer-bist-du';
    },
    login(email, password) {
      this.$store.state.credentials = {
        password, email,
      };
      firebase
        .auth()
        .signInWithEmailAndPassword(email.toLowerCase().trim(), password)
        .then((userRecord) => {
          const { user } = userRecord;

          const user_id = user.uid;
          this.$store.state.user_id = user_id;
          const userType = user.displayName;
          this.$store.state.userType = userType;
          return { user_id, userType };
        })
        .then(resp => db
          .collection(resp.userType)
          .doc(resp.user_id)
          .get())
        .then((snapshot) => {
          const document = snapshot.data();
          this.$store.state.user_data = document;

          return { userType: document.userType, swipesLeft: document.swipesLeft };
        })
        .then((data) => {
          this.$store.dispatch('bindUserData');
          return data;
        })
        .then((data) => {
          this.$store.dispatch('setSubscriptionData');
          this.$store.dispatch('setUserPayments');
          return data;
        })
        .then((data) => {
          this.redirectToUserType(data.userType);
          return data;
        })
        // .then((data) => {
        //   const daysForFreeSwipes = this.howManyDaysFromLastSwipeUsed();
        //   if (data.swipesLeft === 0) {
        //     if (daysForFreeSwipes >= 7) {
        //       this.$store.dispatch('setUserFreeSwipes');
        //     } else {
        //       this.$store.state.buy_swipes_dialog = true;
        //     }
        //   }
        // })
        .catch((error) => {
          if (
            error.code === 'auth/wrong-password'
            || error.code === 'auth/user-not-found'
          ) {
            this.$store.state.snackText = 'Falsche Logindaten';
            this.$store.state.snackbar = true;
          }
          if (error.code === 'auth/invalid-email') {
            this.$store.state.snackText = 'E-Mail hat das falsche Format';
            this.$store.state.snackbar = true;
          }
        });
    },
  },

  created() {
    document.body.classList.remove('main-background');
  },
};
</script>

<style lang="scss" scoped>
.logo-round {
  // width: 100px;
  height: 100px;
  // border-radius: 50%;
  // border: 1px solid white;
}

.row {
  display: flex;
  align-items: center;
  margin-top: 15px;
  .divider {
    margin: 15px;
  }
}

.card-text {
  text-align: left;
}

.login {
  min-height: 100vh;
  overflow: hidden;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  a {
    text-decoration: none;
  }
}
.login-btn {
  margin-bottom: 15px;
}

.background {
  // position: fixed;
  // right: 0;
  // top: 0;
  // max-height: 100vh;
  // min-width: 100vw;
  height: 100%;
  width: 100%;

  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

  background: #000000; /* Old browsers */
  background: -moz-linear-gradient(
    left,
    #303030 0%,
    #000000 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #303030 0%,
    #000000 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to left,
    #303030 0%,
    #000000 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#303030', endColorstr='#000000',GradientType=0 ); /* IE6-9 */
}

.team-link {
  position: absolute;
  color: white;
  right: 10px;
  top: 10px;
}

.team-link-2 {
  position: absolute;
  color: white;
  right: 10px;
  top: 40px;
}

.login-content {
  position: relative;
  color: white;
}

.login-wrapper {
  margin-top: 50px;
  margin-bottom: 50px;
  h1 {
    margin-bottom: 15px;
  }
  max-width: 500px;
  min-height: 400px;
  display: flex;
  width: 90%;
  flex-direction: column;
  border-radius: 20px;
  padding: 25px;
}

.register {
  color: black;
  font-weight: 500;
  text-decoration: none;
  margin-top: 15px;
  margin-bottom: 20px;
}
.forgotPW {
  position: relative;
  color: rgb(134, 134, 134);
  margin-top: 25px;
  font-weight: 500;
  text-decoration: none;
}

.back-to-website {
  position: absolute;
  left: 10px;
  top: 10px;
  color: white;
  font-weight: bold;
  display: flex;
  align-items: center;

  .btn {
    color: white;
    background: rgb(23,161,60);
    padding: 6px 10px;
    border-radius: 5px;
  }
}
</style>
